<div class="salesorder-container">
  <div class="salesorder-header">
    <h2>{{ salesOrderId ? (isEditMode ? 'Edit Sales Order' : 'View Sales Order') : 'Create New Sales Order' }}</h2>
    <div class="header-actions">
      <button *ngIf="salesOrderId && !isEditMode" mat-icon-button (click)="downloadPdf()" type="button" matTooltip="Create PDF">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
      <button *ngIf="salesOrderId && !isEditMode" mat-icon-button (click)="downloadLabels()" type="button" matTooltip="Create Labels">
        <mat-icon>description</mat-icon>
      </button>
      <button *ngIf="salesOrderId && !isEditMode" mat-raised-button color="accent" (click)="enterEditMode()" type="button">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>
  </div>

  <!-- Related Records -->
  <mat-expansion-panel *ngIf="purchaseOrders.length > 0 || salesInvoices.length > 0 || proformas.length > 0 || salesOrderId" class="related-section" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Related</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="related-subsection">
      <div class="related-subsection-header">
        <h4>Purchase Orders</h4>
        <button *ngIf="isEditMode && salesOrderId" mat-icon-button color="primary" type="button" (click)="openLinkPODialog()" matTooltip="Link existing purchase order">
          <mat-icon>add_link</mat-icon>
        </button>
      </div>
      <table *ngIf="purchaseOrders.length > 0" mat-table [dataSource]="purchaseOrders" class="related-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Order #</th>
          <td mat-cell *matCellDef="let po">{{ po.number }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let po">{{ po.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let po">{{ po.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let po">{{ po.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let po">
            <button mat-icon-button color="primary" (click)="viewPurchaseOrder(po.id); $event.stopPropagation()" type="button" matTooltip="View Purchase Order">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button *ngIf="isEditMode" mat-icon-button color="warn" (click)="removePurchaseOrder(po.id); $event.stopPropagation()" type="button" matTooltip="Remove from related">
              <mat-icon>link_off</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="purchaseOrderColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: purchaseOrderColumns;" class="clickable-row" (click)="viewPurchaseOrder(row.id)"></tr>
      </table>
    </div>

    <div class="related-subsection">
      <div class="related-subsection-header">
        <h4>Sales Invoices</h4>
        <button *ngIf="isEditMode && salesOrderId" mat-icon-button color="primary" type="button" (click)="openLinkInvoiceDialog()" matTooltip="Link existing sales invoice">
          <mat-icon>add_link</mat-icon>
        </button>
        <button *ngIf="!isEditMode && salesOrderId" mat-icon-button color="accent" type="button" (click)="createSalesInvoice()" matTooltip="Create a new Sales Invoice pre-populated with this order's details">
          <mat-icon>post_add</mat-icon>
        </button>
      </div>
      <p *ngIf="pendingInventoryError" class="error-message">
        <mat-icon>error_outline</mat-icon>
        Pending inventory is still outstanding and needs to be completed before creating an invoice for it.
        <a routerLink="/products">Go to Products</a>
      </p>
      <table *ngIf="salesInvoices.length > 0" mat-table [dataSource]="salesInvoices" class="related-table">
        <ng-container matColumnDef="invoiceNumber">
          <th mat-header-cell *matHeaderCellDef>Invoice #</th>
          <td mat-cell *matCellDef="let si">{{ si.invoiceNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let si">{{ si.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let si">{{ si.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let si">{{ si.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="siActions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let si">
            <button mat-icon-button color="primary" (click)="viewSalesInvoice(si.id); $event.stopPropagation()" type="button" matTooltip="View Sales Invoice">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button *ngIf="isEditMode" mat-icon-button color="warn" (click)="removeSalesInvoice(si.id); $event.stopPropagation()" type="button" matTooltip="Remove from related">
              <mat-icon>link_off</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="salesInvoiceColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: salesInvoiceColumns;" class="clickable-row" (click)="viewSalesInvoice(row.id)"></tr>
      </table>
    </div>

    <div class="related-subsection">
      <div class="related-subsection-header">
        <h4>Proformas</h4>
        <button *ngIf="!isEditMode && salesOrderId" mat-icon-button color="primary" type="button" (click)="createSalesProforma()" matTooltip="Create a new Sales Proforma pre-populated with this order's details">
          <mat-icon>request_quote</mat-icon>
        </button>
      </div>
      <table *ngIf="proformas.length > 0" mat-table [dataSource]="proformas" class="related-table">
        <ng-container matColumnDef="proformaNumber">
          <th mat-header-cell *matHeaderCellDef>Proforma #</th>
          <td mat-cell *matCellDef="let pf">{{ pf.proformaNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let pf">{{ pf.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let pf">{{ pf.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let pf">{{ pf.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="pfActions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let pf">
            <button mat-icon-button color="primary" (click)="viewProforma(pf.id); $event.stopPropagation()" type="button" matTooltip="View Proforma">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="proformaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: proformaColumns;" class="clickable-row" (click)="viewProforma(row.id)"></tr>
      </table>
    </div>
  </mat-expansion-panel>

  <form [formGroup]="salesOrderForm" (ngSubmit)="onSubmit()" class="salesorder-form" [class.view-mode]="!isEditMode">
    <!-- Order Information Section -->
    <h3>Order Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Order Number</mat-label>
        <input matInput formControlName="number" placeholder="Enter order number" [readonly]="!isEditMode">
        <mat-error *ngIf="salesOrderForm.get('number')?.hasError('required')">
          Order number is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Order Date</mat-label>
        <input matInput [matDatepicker]="orderDatePicker" formControlName="date" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="orderDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #orderDatePicker></mat-datepicker>
        <mat-error *ngIf="salesOrderForm.get('date')?.hasError('required')">
          Order date is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" [disabled]="!isEditMode">
          <mat-option *ngFor="let status of orderStatuses" [value]="status.name">{{ status.description }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Sales Person</mat-label>
        <input matInput formControlName="salesPerson" placeholder="Enter sales person name" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <!-- Customer Information Section -->
    <h3>Customer Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput 
               formControlName="customerSearch" 
               placeholder="Search customer by name or ID"
               [readonly]="!isEditMode"
               [matAutocomplete]="autoCustomer">
        <button mat-icon-button matSuffix 
                *ngIf="salesOrderForm.get('customerSearch')?.value && isEditMode"
                (click)="clearCustomer(); $event.stopPropagation()"
                type="button"
                matTooltip="Clear customer">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #autoCustomer="matAutocomplete" 
                          [displayWith]="displayCustomer.bind(this)"
                          (optionSelected)="onCustomerSelected($event.option.value)">
          <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
            {{ customer.name || customer.Name }} (ID: {{ customer.id || customer.Id }})
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="salesOrderForm.get('customerId')?.hasError('required')">
          Customer is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer PO</mat-label>
        <input matInput formControlName="customerPO" placeholder="Enter customer PO" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer Contact</mat-label>
        <mat-select formControlName="customerContactId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let contact of customerContacts" [value]="contact.id || contact.Id">
            {{ contact.firstName || contact.FirstName }} {{ contact.lastName || contact.LastName }}
            <span *ngIf="contact.email || contact.Email" class="contact-option-hint">
              &mdash; {{ contact.email || contact.Email }}
            </span>
            <span *ngIf="contact.phone || contact.Phone" class="contact-option-hint">
              &mdash; {{ contact.phone || contact.Phone }}
            </span>
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="salesOrderForm.get('customerContactId')?.value"
          [matTooltip]="getContactTooltip(salesOrderForm.get('customerContactId')?.value)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>
    </div>

    <!-- Address Information Section -->
    <h3>Address Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Bill To Address</mat-label>
        <mat-select formControlName="billToAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of customerAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="salesOrderForm.get('billToAddressId')?.value"
          [matTooltip]="getAddressTooltip(salesOrderForm.get('billToAddressId')?.value, customerAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship To Address</mat-label>
        <mat-select formControlName="shipToAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of customerAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="salesOrderForm.get('shipToAddressId')?.value"
          [matTooltip]="getAddressTooltip(salesOrderForm.get('shipToAddressId')?.value, customerAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>
    </div>

    <!-- Shipping Information Section -->
    <h3>Shipping Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipper</mat-label>
        <input matInput formControlName="shipper" placeholder="Enter shipper name" [readonly]="!isEditMode">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Account Number</mat-label>
        <input matInput formControlName="shipAccountNum" placeholder="Enter account number" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field" style="display: none;">
        <mat-label>Ship Terms</mat-label>
        <input matInput formControlName="shipTerms" placeholder="Enter shipping terms" [readonly]="!isEditMode">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Payment Terms</mat-label>
        <mat-select formControlName="paymentTerms" [disabled]="!isEditMode">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let term of paymentTermsList" [value]="term.name">{{ term.description }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Desired Ship Date</mat-label>
        <input matInput [matDatepicker]="shipDatePicker" formControlName="desiredShipDate" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="shipDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #shipDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Ship Attention To</mat-label>
        <input matInput formControlName="shipAttentionTo" placeholder="Attention to name" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <!-- Products Section -->
    <div class="section-header">
      <h3>Products</h3>
      <div *ngIf="isEditMode" class="add-product-buttons">
        <button mat-stroked-button color="primary" type="button" (click)="addPurchaseOrderProduct()" matTooltip="Add pending PO product">
          <mat-icon>inventory_2</mat-icon> PO Product
        </button>
        <button mat-stroked-button color="accent" type="button" (click)="addLotNumProduct()" matTooltip="Add lot number">
          <mat-icon>qr_code</mat-icon> Lot Number
        </button>
      </div>
    </div>

    <mat-accordion formArrayName="products">
      <mat-expansion-panel *ngFor="let product of products.controls; let i = index" [formGroupName]="i">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ getProductTitle(i) }}
          </mat-panel-title>
          <mat-panel-description>
            <button mat-icon-button color="warn" type="button" (click)="removeProduct(i); $event.stopPropagation()" matTooltip="Remove Product" *ngIf="isEditMode">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>
        
        <!-- PO Product selection -->
        <ng-container *ngIf="product.get('lineItemType')?.value === 'purchaseOrderProduct'">
          <div class="form-row">
            <input type="hidden" formControlName="purchaseOrderProductId">
            <input type="hidden" formControlName="productId">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>PO Product</mat-label>
              <mat-icon matPrefix>inventory_2</mat-icon>
              <input matInput
                     formControlName="purchaseOrderProductSearch"
                     placeholder="Search by PO #, catalog #, or product name"
                     [readonly]="!isEditMode"
                     [matAutocomplete]="autoPOProduct">
              <button mat-icon-button matSuffix
                      *ngIf="product.get('purchaseOrderProductSearch')?.value && isEditMode"
                      (click)="clearPurchaseOrderProduct(i); $event.stopPropagation()"
                      type="button"
                      matTooltip="Clear PO product">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #autoPOProduct="matAutocomplete"
                                [displayWith]="displayPurchaseOrderProduct.bind(this)"
                                (optionSelected)="onPurchaseOrderProductSelected(i, $event.option.value)">
                <mat-option *ngFor="let pop of filteredPurchaseOrderProductsList[i] | async" [value]="pop">
                  <span class="lot-num-option-num">{{ pop.purchaseOrder?.number || pop.purchaseOrder?.Number || '' }}</span>
                  <span class="lot-num-option-hint">
                    &mdash; {{ pop.vendorProduct?.product?.name || pop.vendorProduct?.product?.Name || pop.product?.name || pop.product?.Name || '' }}
                    <span *ngIf="pop.vendorProduct?.product?.catalogNum || pop.vendorProduct?.product?.CatalogNum || pop.product?.catalogNum || pop.product?.CatalogNum">
                      [{{ pop.vendorProduct?.product?.catalogNum || pop.vendorProduct?.product?.CatalogNum || pop.product?.catalogNum || pop.product?.CatalogNum }}]
                    </span>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </ng-container>

        <!-- Lot Number selection -->
        <ng-container *ngIf="product.get('lineItemType')?.value === 'lotNum'">
          <div class="form-row">
            <input type="hidden" formControlName="lotNumId">
            <input type="hidden" formControlName="productId">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>FITZIDX Lot Number</mat-label>
              <mat-icon matPrefix>qr_code</mat-icon>
              <input matInput
                     formControlName="lotNumSearch"
                     placeholder="Search by lot #, catalog #, or product name"
                     [readonly]="!isEditMode"
                     [matAutocomplete]="autoLotNum">
              <button mat-icon-button matSuffix
                      *ngIf="product.get('lotNumSearch')?.value && isEditMode"
                      (click)="clearLotNum(i); $event.stopPropagation()"
                      type="button"
                      matTooltip="Clear lot number">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #autoLotNum="matAutocomplete"
                                [displayWith]="displayLotNum.bind(this)"
                                (optionSelected)="onLotNumSelected(i, $event.option.value)">
                <mat-option *ngFor="let ln of filteredLotNumsList[i] | async" [value]="ln">
                  <span class="lot-num-option-num">{{ ln.number || ln.Number }}</span>
                  <span class="lot-num-option-hint">
                    &mdash; {{ ln.vendorProduct?.product?.name || ln.vendorProduct?.product?.Name || ln.product?.name || ln.product?.Name || '' }}
                    <span *ngIf="ln.vendorProduct?.product?.catalogNum || ln.vendorProduct?.product?.CatalogNum || ln.product?.catalogNum || ln.product?.CatalogNum">
                      [{{ ln.vendorProduct?.product?.catalogNum || ln.vendorProduct?.product?.CatalogNum || ln.product?.catalogNum || ln.product?.CatalogNum }}]
                    </span>
                    <span *ngIf="ln.vendorProduct?.vendor?.name || ln.vendorProduct?.vendor?.Name">
                      &mdash; {{ ln.vendorProduct?.vendor?.name || ln.vendorProduct?.vendor?.Name }}
                    </span>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>FITZIDX Catalog #</mat-label>
              <input matInput formControlName="catalogNum" placeholder="Auto-filled from lot number" readonly>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Vendor Catalog #</mat-label>
              <input matInput formControlName="vendorCatalogNum" placeholder="—" readonly>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Vendor Lot #</mat-label>
              <input matInput formControlName="vendorLotNum" placeholder="—" readonly>
            </mat-form-field>
          </div>
        </ng-container>

        <!-- Common: product name + catalog # -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" *ngIf="false">
            <mat-label>Product</mat-label>
            <input matInput formControlName="productName" placeholder="Auto-filled" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" *ngIf="product.get('lineItemType')?.value === 'purchaseOrderProduct'">
            <mat-label>FITZIDX Catalog #</mat-label>
            <input matInput formControlName="catalogNum" placeholder="Auto-filled" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" *ngIf="product.get('lineItemType')?.value === 'purchaseOrderProduct'">
            <mat-label>FITZIDX Lot #</mat-label>
            <input  matInput [value]="getLotNumLabel(product.get('lotNumId')?.value)" placeholder="—" readonly>
          </mat-form-field>
        </div>

         <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" *ngIf="product.get('lineItemType')?.value === 'purchaseOrderProduct'">
            <mat-label>Vendor Catalog #</mat-label>
            <input matInput formControlName="vendorCatalogNum" placeholder="Auto-filled" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" *ngIf="product.get('lineItemType')?.value === 'purchaseOrderProduct'">
            <mat-label>Vendor Lot #</mat-label>
            <input matInput formControlName="vendorLotNum" placeholder="—" readonly>
          </mat-form-field>
         </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" placeholder="Line item description" [readonly]="!isEditMode">
          </mat-form-field>

           <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Desired Packaging</mat-label>
            <input matInput formControlName="desiredPackaging" [readonly]="!isEditMode">
          </mat-form-field>
        </div>

        <!-- Common: pricing and quantity -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Price</mat-label>
            <input matInput type="number" formControlName="unitPrice" placeholder="0.00" step="0.01" [readonly]="!isEditMode">
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('required')">
              Unit price is required
            </mat-error>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('min')">
              Price must be positive
            </mat-error>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="form-field">
            <input matInput type="number" formControlName="quantityAvailable" placeholder="Qty Available" readonly>
            <mat-hint>Available</mat-hint>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" formControlName="quantity" placeholder="1" step="0.01" [readonly]="!isEditMode">
            <mat-hint *ngIf="isEditMode && product.get('quantityAvailable')?.value !== null" [class.quantity-hint-exceeded]="isQuantityExceeded(i)">
              Available: {{ product.get('quantityAvailable')?.value }}
            </mat-hint>
            <mat-error *ngIf="product.get('quantity')?.hasError('required')">
              Quantity is required
            </mat-error>
            <mat-error *ngIf="product.get('quantity')?.hasError('min')">
              Quantity must be greater than 0
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Type</mat-label>
            <mat-select formControlName="unitType" [disabled]="!isEditMode">
              <mat-option *ngFor="let type of unitTypes" [value]="type">{{ type | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <input type="hidden" formControlName="lineNumber">

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>PO Number</mat-label>
            <input matInput formControlName="poNumber" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>COG/unit</mat-label>
            <input matInput type="number" formControlName="costPerUnit" placeholder="0.00" step="0.01" [readonly]="!isEditMode">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>

        <!-- <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes" rows="2" placeholder="Line item notes" [readonly]="!isEditMode"></textarea>
          </mat-form-field>
        </div> -->
      </mat-expansion-panel>

      <div *ngIf="products.length === 0" class="empty-message">
        No products added. Use the buttons above to add a line item.
      </div>
    </mat-accordion>

    <!-- Financial Information Section -->
    <h3>Financial Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Tax Amount</mat-label>
        <input matInput type="number" formControlName="taxAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesOrderForm.get('taxAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Fee</mat-label>
        <input matInput type="number" formControlName="shipFee" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesOrderForm.get('shipFee')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Handling Fee</mat-label>
        <input matInput type="number" formControlName="handlingFee" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesOrderForm.get('handlingFee')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Discount Amount</mat-label>
        <input matInput type="number" formControlName="discountAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesOrderForm.get('discountAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Tax Amount</mat-label>
        <input matInput type="number" formControlName="taxAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesOrderForm.get('taxAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Order Total Section -->
    <div *ngIf="products.length > 0" class="total-section">
      <div class="total-row">
        <span class="total-label">Subtotal:</span>
        <span class="total-amount">{{ getLineItemsTotal() | currency }}</span>
      </div>
      <div class="total-row" *ngIf="salesOrderForm.get('discountAmount')?.value > 0">
        <span class="total-label discount">Discount:</span>
        <span class="total-amount discount">-{{ salesOrderForm.get('discountAmount')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="salesOrderForm.get('taxAmount')?.value > 0">
        <span class="total-label">Tax:</span>
        <span class="total-amount">{{ salesOrderForm.get('taxAmount')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="salesOrderForm.get('shipFee')?.value > 0">
        <span class="total-label">Shipping:</span>
        <span class="total-amount">{{ salesOrderForm.get('shipFee')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="salesOrderForm.get('handlingFee')?.value > 0">
        <span class="total-label">Handling Fee:</span>
        <span class="total-amount">{{ salesOrderForm.get('handlingFee')?.value | currency }}</span>
      </div>
      <div class="total-row total-highlight">
        <span class="total-label">Order Total:</span>
        <span class="total-amount">{{ calculateTotal() | currency }}</span>
      </div>
    </div>

    <div class="form-actions" *ngIf="isEditMode">
      <button mat-raised-button color="primary" type="submit" [disabled]="!salesOrderForm.valid">
        Save
      </button>
      <button mat-raised-button type="button" (click)="onCancel()">
        Cancel
      </button>
    </div>

  </form>

  <p *ngIf="errorMessage" class="error-message">
    <mat-icon>error_outline</mat-icon>
    {{ errorMessage }}
  </p>
</div>
